import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DispatchBoardComponent } from './components/dispatch-board/dispatch-board.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from 'app/shared/shared.module';
import { SettingsComponent } from './components/settings/settings.component';
import { BryntumCoreModule } from '@bryntum/core-angular-thin';
import { BryntumGridModule } from '@bryntum/grid-angular-thin';
import { BryntumSchedulerModule } from '@bryntum/scheduler-angular-thin';
import { BryntumSchedulerProModule } from '@bryntum/schedulerpro-angular-thin';
import { AttributePickerComponent } from './components/attribute-picker/attribute-picker.component';
import { CardDetailsSelectorComponent } from './components/card-details-selector/card-details-selector.component';
import { PreviewDataModule } from 'app/components/preview-data/preview-data.module';
import { ShimmerModule } from 'app/components/shimmer/shimmer.module';
import { MapsModule } from 'app/modules/maps/maps.module';
import { EmployeePreviewComponent } from 'app/components/preview-popover/employee-preview/employee-preview.component';
import { DispatchFilterComponent } from './components/dispatch-filter/dispatch-filter.component';
import { ManageDispatchFilterComponent } from './components/manage-dispatch-filter/manage-dispatch-filter.component';
import { DispatchFilterDrawerComponent } from './components/dispatch-filter/dispatch-filter-drawer/dispatch-filter-drawer.component';
import { RescheduleJobComponent } from './components/reschedule-job/reschedule-job.component';
import { RouteFormModule } from 'app/components/route-form/route-form.module';
import { RemarksComponent } from './components/remarks/remarks.component';
import { DispatchBoardRoutesComponent } from './components/dispatch-board-routes/dispatch-board-routes.component';
import { ContactInfoFormModule } from 'app/components/contact-info/contact-info.module';
import { DataPickerModule } from 'app/components/data-picker/data-picker.module';
import { JobFormModule } from 'app/modules/jobs/job-form/job-form.module';
import { RouteDetailsModule } from 'app/components/route-details/route-details.module';
import { AssignRouteModule } from 'app/components/assign-route/assign-route.component.module';
import { RescheduleRouteComponent } from './components/reschedule-route/reschedule-route.component';
import { NewJobModule } from 'app/components/new-job/new-job.module';
import { ListKeywordFilterPipe } from 'app/core/pipes/listKeywordFilter.pipe';
import { DispatchAdvancedFilterComponent } from './components/dispatch-advanced-filter/dispatch-advanced-filter.component';
import { BryntumGanttModule } from '@bryntum/gantt-angular-thin';
import { AutofocusDirective } from 'app/directives/autofocus.directive';
import { CreateRouteFormModule } from 'app/components/create-route-form/create-route-form.module';
import { QuickAssignEmployeeModule } from 'app/components/quick-assign-employee/quick-assign-employee.module';
import { RecurringRouteDetailsModule } from 'app/components/recurring-route-details/recurring-route-details.module';
import { RoutePickerModule } from 'app/components/route-picker/route-picker.module';
import { MoveRouteJobModule } from 'app/components/move-route-job/move-route-job.module';
import { CreateNonJobEventModule } from 'app/components/create-non-job-event/create-non-job-event.module';
import { NonJobEventDetailsModule } from 'app/components/non-job-event-details/non-job-event-details.module';
import { CreateColorProfileModule } from 'app/components/create-color-profile/create-color-profile.module';

// AoT requires an exported function for factories
const httpLoaderFactory = (http: HttpClient): any =>new TranslateHttpLoader(http,'../../../src/assets/i18n/en/en.json','.json');

const providers = [];

@NgModule({
  declarations: [
    AppComponent,
    DispatchBoardComponent,
    SettingsComponent,
    AttributePickerComponent,
    CardDetailsSelectorComponent,
    EmployeePreviewComponent,
    DispatchFilterDrawerComponent,
    DispatchFilterComponent,
    ManageDispatchFilterComponent,
    RescheduleJobComponent,
    RemarksComponent,
    DispatchBoardRoutesComponent,
    RescheduleRouteComponent,
    ListKeywordFilterPipe,
    DispatchAdvancedFilterComponent,
    AutofocusDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BryntumSchedulerProModule,
    TranslateModule.forRoot({
      loader:{
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps:[HttpClient]
      }
  }),
  SharedModule,
  PreviewDataModule,
  ShimmerModule,
  MapsModule,
  RouteFormModule,
  ContactInfoFormModule,
  DataPickerModule,
  NewJobModule,
  JobFormModule,
  RouteDetailsModule,
  AssignRouteModule,
  BryntumCoreModule,
  BryntumGridModule,
  BryntumSchedulerModule,
  BryntumSchedulerProModule,
  BryntumGanttModule,
  CreateRouteFormModule,
  QuickAssignEmployeeModule,
  RecurringRouteDetailsModule,
  RoutePickerModule,
  MoveRouteJobModule,
  CreateNonJobEventModule,
  NonJobEventDetailsModule,
  CreateColorProfileModule
  ],
  providers: providers,
  bootstrap: [AppComponent]
})

export class AppModule { }

@NgModule({})
export class DispatchBoardSharedModule{
  static forRoot(): ModuleWithProviders<AppModule> {
    return {
      ngModule: AppModule,
      providers: providers
    };
  }
}
